import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useEmployeeNumberFilter } from "../../../../../TimeSheet/Team/Actions/useFilters/useEmployeeNumberFilter";
import { useFirstNameFilter } from "../../../../../TimeSheet/Team/Actions/useFilters/useFirstNameFilter";
import { useLastNameFilter } from "../../../../../TimeSheet/Team/Actions/useFilters/useLastNameFilter";
import { useFilters as useTimeSheetFilters } from "../../../../../TimeSheet/Home/Actions/useFilters";
import { useProjectFilter } from "../../../../../TimeSheet/Team/Actions/useFilters/useProjectFilter";
import { useUnionFilter } from "../../../../../TimeSheet/Team/Actions/useFilters/useUnionFilter";
import { useCalculationGroupFilter } from "../../../../../TimeSheet/Team/Actions/useFilters/useCalculationGroupFilter";
import { useUserFilters } from "../../hooks/useUserFilters";
import { toConfig } from "../../helpers";

export const useFilters = () => {
    const { t } = useTranslation();
    const employeeNumberFilter = useEmployeeNumberFilter();
    const firstNameFilter = useFirstNameFilter();
    const lastNameFilter = useLastNameFilter();
    const timeSheetFilters = useTimeSheetFilters();
    const levelFilters = useMemo(() => {
        return timeSheetFilters.filter(({ id }: any) => id.indexOf("level") === 0);
    }, [timeSheetFilters]);
    const otherTimesheetFilters = useMemo(() => {
        return timeSheetFilters.filter(({ id }: any) => !(id.indexOf("level") === 0));
    }, [timeSheetFilters]);
    const projectFilter = useProjectFilter();
    const calculationGroupFilter = useCalculationGroupFilter();
    const unionFilter = useUnionFilter();
    const { userGroupFilter, employmentTypeFilter, salaryOrHourlyFilter, customFieldsFilters } = useUserFilters();

    return useMemo(() => toConfig([
        employeeNumberFilter,
        firstNameFilter,
        lastNameFilter,
        ...levelFilters,
        {
            id: "payGroup",
            Header: t("pay-group"),
            canFilter: true,
            filter: "resource-select",
            disableFilters: false,
        },
        projectFilter,
        calculationGroupFilter,
        unionFilter,
        userGroupFilter,
        employmentTypeFilter,
        salaryOrHourlyFilter,
        ...otherTimesheetFilters,
        ...customFieldsFilters,
    ]), [
        employeeNumberFilter,
        firstNameFilter,
        lastNameFilter,
        levelFilters,
        projectFilter,
        calculationGroupFilter,
        unionFilter,
        otherTimesheetFilters,
        userGroupFilter,
        employmentTypeFilter,
        salaryOrHourlyFilter,
        customFieldsFilters,
        t,
    ]);
};
